//@ commons
const { APIGet } = require('utilities/APIRequestHelper');

//@ constants
const {
    MORTGAGE_REQUEST_FETCH_PARTICIPANTS_OPERATIVE_REQUEST,
    MORTGAGE_REQUEST_FETCH_PARTICIPANTS_OPERATIVE_SUCCESS,
    MORTGAGE_REQUEST_FETCH_PARTICIPANTS_OPERATIVE_FAILURE
} = require('constants/actionTypes');

const requestFetchOperativeParticipants = () => ({
    type: MORTGAGE_REQUEST_FETCH_PARTICIPANTS_OPERATIVE_REQUEST
});

const requestFetchOperativeParticipantSucces = (participants) => ({
    type: MORTGAGE_REQUEST_FETCH_PARTICIPANTS_OPERATIVE_SUCCESS,
    data: {
        participants
    }
});

const requestFetchOperativeParticipantsFailure = (error) => ({
    type: MORTGAGE_REQUEST_FETCH_PARTICIPANTS_OPERATIVE_FAILURE,
    data: {
        error
    }
});

const requestDataOperativeParticipants = (numeroContrato, producto) => (dispatch) => {

    const requestData = {
        query: {
            producto,
            numeroContrato
        }
    }

    dispatch(requestFetchOperativeParticipants());

    return APIGet({
        dispatch,
        endpoint: 'mortgageRequestDataOperativeParticipants',
        params: requestData

    })
    .then(response => dispatch(requestFetchOperativeParticipantSucces(response)))
    .catch(response => {
        if (!!response.error){
            dispatch(requestFetchOperativeParticipantsFailure(response.error))
        } else {
            throw response;
        }
    });
}

module.exports = {
    requestDataOperativeParticipants
}
